import { AfterContentChecked, ChangeDetectorRef, Component } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ICellRendererAngularComp } from 'ag-grid-angular';

import { DateFormatService, MenuService } from '../../../../services';
import { BaseRendererComponent } from '../base-renderer/base-renderer.component';

@Component({
  selector: 'app-date-renderer',
  templateUrl: './date-renderer.component.html',
  styleUrl: './date-renderer.component.scss',
})
export class DateRendererComponent
  extends BaseRendererComponent
  implements AfterContentChecked, ICellRendererAngularComp
{
  constructor(
    public menuService: MenuService,
    public dateFormatService: DateFormatService,
    private cdRef: ChangeDetectorRef,
  ) {
    super();
  }

  ngAfterContentChecked() {
    this.cdRef.detectChanges();
  }

  onDateChanged(dateString: string) {
    let date = this.dateFormatService.dateFromString(dateString);
    this.params.node.setDataValue(this.params.column.getColId(), date);
  }

  onDatePicked(ngbDate: NgbDateStruct) {
    const date = this.dateFormatService.dateFromNgbDate(ngbDate);
    this.params.node.setDataValue(this.params.column.getColId(), date);
  }
}
